export default "__VITE_ASSET__7WQGJyq9__"